import classNames from "classnames";
import { trpc } from "../../../utils/trpc";
import { RemovingThrobber } from "../../removing_throbber";
import { toast } from "react-hot-toast";

export function RestoreDiscordPurchasesButton() {
	const utils = trpc.useContext();
	const mutation = trpc.premium.restoreDiscordPurchases.useMutation({
		onSuccess: () => {
			utils.premium.getUserPremiumDetails.invalidate();
			toast.success("Purchases restored successfully!");
		},
	});

	return (
		<div className="mt-8 flex items-center gap-2">
			<div
				className={classNames({
					invisible: !mutation.isLoading,
				})}
			>
				<RemovingThrobber />
			</div>
			<button
				onClick={() => mutation.mutate()}
				className={classNames("manual-link", {
					"input-disabled": mutation.isLoading,
				})}
			>
				Restore Purchases
			</button>
		</div>
	);
}
